import { AfterViewInit, Component, OnInit } from '@angular/core';
import { TableComponent, TableDataSource } from 'src/app/gigmonster/components/table/table.component';
import { ContentService } from 'src/app/base/services/content/content.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AppidService } from 'src/app/base/services/appid/appid.service';

@Component({
    selector: 'app-easysuite-table',
    templateUrl: './easysuite-table.component.html',
    styleUrls: ['./easysuite-table.component.css']
})
export class EasysuiteTableComponent extends TableComponent implements OnInit, AfterViewInit {

    paginatorInfo: EasysuitePaginatorInfo;
    Header: any;
    objectKeys = Object.keys;
    public GUIthemeID: number;
    moreDescriptionVisible: boolean = true;

    constructor(public contentService: ContentService, public router: Router, public route: ActivatedRoute, public appIdService: AppidService) {
        super(contentService, router, route, appIdService)
        
        this.GUIthemeID = this.appIdService.GUIthemeID;
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.paginatorInfo = new EasysuitePaginatorInfo(this.dataSource, this.pageID, this.GUIthemeID, this.table.tableID, this);
        this.moreDescriptionVisible = false;

        // With this we avoid errors with subscriptions from the parent component to the paginator like multiple executions of the callback.
        this.reloadSubscription.unsubscribe();
        this.reloadSubscription = this.reloadNotifier.subscribe((x) => {
            this.reloadParams = x || {};
            this.dataSource.refetchDataOnLoad();
            this.dataSource.loadData(this.table.tableID, '', 'asc', 1, this.paginatorInfo.pageSize, this.pageID, x);
        });

        this.dataSource.connect().subscribe(data => {
            this.visibleRowsCount = data.length;
        });
    }

    ngAfterViewInit(): void {
        //load the initial data for the table
        this.dataSource.loadData(this.table.tableID, '', 'asc', 1, 25, this.pageID, this.route.snapshot.queryParams);
    }

    public sortData(event: any): void {
        this.tableSortOrderText = false;

        // Get the page index from paginator if available, otherwise from paginatorInfo (minus 1 for 0-based indexing)
        const pageIndex = this.paginator?.pageIndex ?? ((this.paginatorInfo?.pageIndex ?? 1) - 1);

        // Get the page size from paginator if available, otherwise from paginatorInfo, default to 25
        const pageSize = this.paginator?.pageSize ?? this.paginatorInfo?.pageSize ?? 25;

        this.dataSource.loadData(
            this.table.tableID,
            event.active,
            event.direction,
            (pageIndex !== undefined ? pageIndex + 1 : 1),
            pageSize,
            this.pageID
        );

        const columnIndex = parseInt(event.active, 10);
        const columnName = this.table.columns[columnIndex]?.header;

        // Converts "User Name" -> "user_name" (snake_case). 
        // This is needed because the backend expects the column name in snake_case format to store it in the dB table table_person_views.
        const snakeCaseName = columnName
            ? columnName.toLowerCase().replace(/\s+/g, '_').replace(/[^\w]/g, '')
            : '';

        // Creates identifier like "Column2=user_name" to store in the dB table table_person_views, where 2 is the index of the column in the table.columns array and user_name is the name of the column in snake_case.
        const selectedColumn = `Column${columnIndex}=${snakeCaseName}`;

        this.contentService.upsertTablePersonViews(
            this.table.tableID,
            selectedColumn,
            event.direction,
            pageSize,
            this.pageID,
        ).subscribe({
            error: console.error
        });
    }

    // This is a temporary solution until we have the dB table table_columns instead of the delimited values in the dB table tables.
    phoneMask(phone: string): string {
        const numbers = phone.replace(/\D/g, '');
    
        if (phone == "") {
            return "";
        }
        
        return `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)}-${numbers.slice(6, 10)}`; 
    }

    toggleSearch() {
        if (this.showSearch) {
            //clear filter
            this.dataSource.loadData(this.table.tableID, '', 'asc', this.paginatorInfo.pageIndex, this.paginatorInfo.pageSize, this.pageID, this.route.snapshot.queryParams);
        }
        this.showSearch = !this.showSearch;
    }

    toggleDescription(): void {
        this.moreDescriptionVisible = !this.moreDescriptionVisible;
    }

    public getHeader(Header): any {
        for (let i = 0; i < this.table.columns.length; i++) {
            Header = this.table.columns[i].header
            if (Header == "Edit" || Header == "Delete") {
                return Header
            }
        }
    }
}


export class EasysuitePaginatorInfo {
    public pageSize: number;
    public pageIndex: number;
    public totalPages: number = 0;
    public dataLength: number;

    private pageID: number;
    private GUIthemeID : number;
    private tableID: number;
    private datasource: TableDataSource;
    private component: any;

    constructor(dataSource: TableDataSource, pageID: number, GUIthemeID: number, tableID: number, component: any) {
        this.datasource = dataSource;
        this.pageID = pageID;
        this.GUIthemeID = GUIthemeID;
        this.tableID = tableID;
        this.component = component;

        this.pageIndex = 1;
        this.pageSize = 25;

        this.datasource.connect().subscribe(data => {
            this.dataLength = this.datasource.dataLength;
            if (this.totalPages == 0) this.totalPages = Math.ceil(this.dataLength / this.pageSize);
            //subscription callback was executed.
        });
    }

    private loadTableData(): void {
        this.datasource.loadData(
            this.tableID, 
            this.component.activeColumnIndex?.toString() || '', 
            this.component.sortDirection || 'asc', 
            this.pageIndex, 
            this.pageSize, 
            this.pageID
        );
    }

    public canGoBack(): boolean {
        return this.pageIndex > 1;
    }

    public canGoForward(): boolean {
        return this.pageIndex < this.totalPages;
    }

    public goBackOnePage(): void {
        if (this.pageIndex > 1) {
            this.pageIndex--;
            this.loadTableData();
        }
    }

    public goBackAllPages(): void {
        if (this.pageIndex > 1) {
            this.pageIndex = 1;
            this.loadTableData();
        }
    }

    public goForwardOnePage(): void {
        if (this.pageIndex < this.totalPages) {
            this.pageIndex = this.pageIndex + 1;
            this.loadTableData();
        }
    }

    public goForwardAllPages(): void {
        if (this.pageIndex < this.totalPages) {
            this.pageIndex = this.totalPages;
            this.loadTableData();
        }
    }

    public setCount($event): void {
        this.pageSize = $event;
        this.pageIndex = 1;
        this.totalPages = Math.ceil(this.dataLength / this.pageSize);
        this.loadTableData();
    }
}